

export interface ModuleProps {
    id: string,
    parentId?: string,
    text?: string,
    title?: string,
    url: string,
    icon?: string,
    sequenceNo: number,
    selected?: boolean,
    onChange?: () => void,
    minWidth?: number,
    onlineOnly?: boolean
    applicationRights: string[],
    mobileThreshold?: number,

    hasMenuItem: boolean,
    canShowOnDashboard?: boolean,
    showOnDashboardByDefault?: boolean,
    routes?: () => JSX.Element,
    dashboard?: React.ComponentType<any>,
}

type RequiredProps = Pick<ModuleProps, 'id' | 'applicationRights' | 'title'>;

export const CreateModuleProps = (props: Partial<ModuleProps> & RequiredProps): ModuleProps => ({
    onlineOnly: true,
    selected: false,
    sequenceNo: 100000,
    url: '',

    hasMenuItem: true,
    canShowOnDashboard: true,
    showOnDashboardByDefault: true,
    ...props
})
